/* ============================================================
   OFFER LOGIC (Metafield-based)
   ============================================================ */

function applyOffers(context) {
  var scope = context || document;
  var anchors = scope.querySelectorAll('[data-offers-target]');
  if (!anchors.length) {
    return;
  }

  anchors.forEach(function(anchor) {
    if (anchor.dataset.offersApplied === 'true') {
      return;
    }

    var promoText = anchor.getAttribute('data-promo-text');
    promoText = promoText ? String(promoText).trim() : '';
    if (!promoText || promoText.toLowerCase() === 'default offer message') {
      anchor.innerHTML = '';
      anchor.dataset.offersApplied = 'true';
      return;
    }

    var isPDP = anchor.hasAttribute('data-pdp');
    anchor.innerHTML = isPDP
      ? '<div class="offer-stack">' + renderOfferTemplate(promoText) + '</div>'
      : renderOfferTemplate(promoText);

    anchor.dataset.offersApplied = 'true';
  });
}

/* ============================================================
   INITIAL LOAD
   ============================================================ */

document.addEventListener('DOMContentLoaded', function() {
  applyOffers();
});

/* ============================================================
   DYNAMIC CONTENT (AJAX / SECTIONS)
   ============================================================ */

var offerObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType !== 1) {
        return;
      }

      if (node.matches && node.matches('[data-offers-target]')) {
        applyOffers(node.parentElement || document);
      } else if (node.querySelector && node.querySelector('[data-offers-target]')) {
        applyOffers(node);
      }
    });
  });
});

offerObserver.observe(document.body, {
  childList: true,
  subtree: true
});

/* ============================================================
   RENDER
   ============================================================ */

function renderOfferTemplate(text) {
  var tpl = document.getElementById('offer-line-template');
  if (!tpl || !text) {
    return '';
  }

  var safeText = String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  return tpl.innerHTML.replace('{{offer_text}}', safeText);
}
